/**
 * "Contas a receber" section copy (ALC-4534). The rows are advisory: they never count toward the
 * checklist progress and never block the close by themselves.
 */
export const arSectionPtBr = {
  title: 'Contas a receber',
  subtitle:
    'Controles consultivos de receita e clientes, fora do progresso do checklist. Eles não bloqueiam o fechamento.',
};

export const arSectionEn: typeof arSectionPtBr = {
  title: 'Accounts receivable',
  subtitle:
    'Advisory revenue and customer controls, outside the checklist progress. They do not block the close.',
};
